<template>
<div class="chapter">
<div class="inner_page">
<p class="fm1"><strong>M.J. Tjia</strong> is a Brisbane-based writer. Her work has been longlisted for the Crime Writers Association (UK) Debut Dagger and the Margery Allingham Short Story Competition. She was awarded a Scarlet Stiletto Award (Australia) in the historical category. She is the author of <em>She Be Damned: A Heloise Chancey Mystery</em> from 2017. <em>A Necessary Murder: A Heloise Chancey Mystery</em> is the second novel in the series.</p>
<p class="fmc">Follow M. J. on Twitter</p>
<p class="fmc"><a href="https://twitter.com/mjtjia?lang=en" target="_blank">@mjtjia</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm01.vue?c1e9d37a